import React from 'react';
import { FormProvider, useForm, WatchObserver } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { Layout, Typography } from 'antd';

import { Statuses } from 'constants/status';
import { useQuery } from 'hooks/useQuery';
import { mapSelect, SelectValue } from 'utils/mappings';
import { debounce, removeEmptyValues } from 'utils/helpers';
import { InputField } from 'components/form/base/InputField';
import { Select } from 'components/form/base/Select';
import { CatalogAsyncSelect } from 'components/form/selects/CatalogAsyncSelect';

import { FILTER_STATUS_OPTIONS } from './constants';

export interface FilterValues {
  nameQuery: string;
  status: Statuses | '';
  categories: SelectValue[] | [];
}

export const Filters = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const methods = useForm<FilterValues>({
    defaultValues: {
      nameQuery: '',
      status: '',
      categories: [],
      ...query,
    },
  });

  const updateFilters = (filterValues: Record<string, string>) => {
    const queryString = new URLSearchParams(filterValues).toString();
    navigate(`${location.pathname}?${queryString}`);
  };

  const debounceSubmit = React.useCallback(
    debounce(({ status, categories, ...values }: FilterValues) => {
      const preparedValues = {
        ...values,
        status: mapSelect(status),
        categories: categories?.length ? mapSelect(categories) || [] : null,
      };
      updateFilters(removeEmptyValues(preparedValues));
    }, 500),
    []
  );

  React.useEffect(() => {
    const subscription = methods.watch(
      methods.handleSubmit(
        debounceSubmit
      ) as unknown as WatchObserver<FilterValues>
    );
    return () => subscription.unsubscribe();
  }, [methods.handleSubmit, methods.watch]);

  return (
    <Layout.Content
      style={{ background: '#fff', paddingTop: 16, paddingBottom: 1 }}
    >
      <Typography.Title level={5} style={{ marginBottom: 24 }}>
        Фильтры
      </Typography.Title>
      <FormProvider {...methods}>
        <form className='ant-form-vertical'>
          <InputField
            name='nameQuery'
            placeholder='Введите название'
            label='Название'
            maxLength={255}
          />
          <Select
            name='status'
            options={FILTER_STATUS_OPTIONS}
            label='Статус'
          />
          <CatalogAsyncSelect
            name='categories'
            requestParams={{
              entityType: 'regulations',
              fieldType: 'categories',
            }}
            label='Категория'
            placeholder='Выберите категорию'
            mode='multiple'
          />
        </form>
      </FormProvider>
    </Layout.Content>
  );
};
